export default {"src":"/_next/static/media/list-icon-straight-arrow-primary.0abd4f6b.svg","height":9,"width":9};